var map = {
	"./Amarilla.svg": 6723,
	"./Cambio formacion.svg": 98631,
	"./Gol de penalti.svg": 86050,
	"./asistencia.svg": 94692,
	"./assist.svg": 68151,
	"./balon blanco lineas.svg": 13333,
	"./balon blanco pintado.svg": 65294,
	"./balon negro lineas.svg": 56259,
	"./balon.svg": 15560,
	"./doble amarilla.svg": 43533,
	"./doubleYellowCard.svg": 90599,
	"./formationChange.svg": 80459,
	"./goal.svg": 21863,
	"./gol en propia.svg": 83370,
	"./in.svg": 47031,
	"./missedPenalty.svg": 10716,
	"./out.svg": 56546,
	"./ownGoal.svg": 45487,
	"./penalty.svg": 66109,
	"./penaltyGoal.svg": 89360,
	"./penaltyGoal2.svg": 26306,
	"./redCard.svg": 89217,
	"./roja.svg": 47708,
	"./yellowCard.svg": 73496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;